import React, { SVGProps } from 'react'
const SvgClockRewind = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'var(--color-cta)'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m15.088 8.053-1.403-1.404-1.404 1.404M13.895 7a6.316 6.316 0 1 1-.874-3.208m-5.442-.3V7l2.106 1.403"
    />
  </svg>
)
export default SvgClockRewind
